import { Effect, Context } from "effect";
import type { InvoiceFinancials } from "../value-objects/InvoiceFinancials";

export interface ShippingPolicySchema {
  readonly isFreeShippingEligible: (
    financials: InvoiceFinancials
  ) => Effect.Effect<boolean, never>;
  // readonly isFreeShippingEligibleWhy: (
  //   financials: InvoiceFinancials
  // ) => Effect.Effect<{ eligible: boolean; threshold: number }, never>;
}

export class ShippingPolicy extends Context.Tag("ShippingPolicy")<
  ShippingPolicy,
  ShippingPolicySchema
>() {}
